export const specialInvoiceCategoryData = [
    {
        "id": "1",
        "code": "1",
        "name": "Επιδοτήσεις – Επιχορηγήσεις"
    },
    {
        "id": "2",
        "code": "2",
        "name": "Έσοδα Λιανικής Ξενοδοχείων"
    },
    {
        "id": "3",
        "code": "3",
        "name": "Λογιστική Εγγραφή"
    },
    {
        "id": "4",
        "code": "4",
        "name": "Tax Free"
    },
    {
        "id": "5",
        "code": "5",
        "name": "Σύνθετες συναλλαγές ημεδαπής – αλλοδαπής"
    },
    {
        "id": "6",
        "code": "6",
        "name": "Δικαιούχοι του άρθρου 3 της υπό στοιχεία 139818 ΕΞ2022/28.09.2022 (Β’5083) κοινής υπουργικής απόφασης"
    },
    {
        "id": "7",
        "code": "7",
        "name": "Αγορά αγροτικών αγαθών υπηρεσιών Άρθρο 41 του Κώδικα ΦΠΑ"
    },
    {
        "id": "8",
        "code": "8",
        "name": "Έσοδα Λιανικών ΦΗΜ ΑΑΔΕ_1"
    },
    {
        "id": "9",
        "code": "9",
        "name": "Έσοδα Λιανικών ΦΗΜ ΑΑΔΕ_2"
    },
    {
        "id": "10",
        "code": "10",
        "name": "Έσοδα Λιανικών ΦΗΜ Επιχείρησης Απόκλιση"
    },
    {
        "id": "11",
        "code": "11",
        "name": "Επίδομα Θέρμανσης"
    },
    {
        "id": "12",
        "code": "12",
        "name": "Συναλλαγές εστίασης"
    },
    {
        "id": "13",
        "code": "13",
        "name": "Ένδειξη Δυσχέρεια Συσχέτισης"
    },
];

export const specialInvoiceCategoryDataProvider = [
    {
        "id": "1",
        "code": "1",
        "name": "Επιδοτήσεις – Επιχορηγήσεις"
    },
    {
        "id": "2",
        "code": "2",
        "name": "Έσοδα Λιανικής Ξενοδοχείων"
    },
    {
        "id": "3",
        "code": "3",
        "name": "Λογιστική Εγγραφή"
    },
    {
        "id": "4",
        "code": "4",
        "name": "Tax Free"
    },
    {
        "id": "5",
        "code": "5",
        "name": "Σύνθετες συναλλαγές ημεδαπής – αλλοδαπής"
    },
    {
        "id": "6",
        "code": "6",
        "name": "Δικαιούχοι του άρθρου 3 της υπό στοιχεία 139818 ΕΞ2022/28.09.2022 (Β’5083) κοινής υπουργικής απόφασης"
    },
    {
        "id": "7",
        "code": "7",
        "name": "Αγορά αγροτικών αγαθών υπηρεσιών Άρθρο 41 του Κώδικα ΦΠΑ"
    },
    {
        "id": "10",
        "code": "10",
        "name": "Έσοδα Λιανικών ΦΗΜ Επιχείρησης Απόκλιση"
    },
    {
        "id": "11",
        "code": "11",
        "name": "Επίδομα Θέρμανσης"
    },
    {
        "id": "12",
        "code": "12",
        "name": "Συναλλαγές εστίασης"
    },
]
